module.exports = __webpack_public_path__ + "img/bird-sale.862d3404.svg";